<template>
  <div class="projektUebersicht">
    <h2>Übersicht</h2>
    <div class="projekteTabelle">
      <BaseLevelTableModule
          :headers="headers"
          :path="pathProjekte"
          formComponent="projekt"
          loading-text="Lade Projekte ..."
          :scrollable="true"
      >
        <template v-slot:searchFilter>
          <v-text-field
              label="Suche"
              searchKey="suche"
              outlined
              dense
              hideDetails="auto"
              clearable
          />
          <v-combobox
              label="Bearbeiter"
              :items="filterValuesBearbeiter"
              item-text="text"
              item-value="key"
              searchKey="bearbeiter"
              hideDetails="auto"
              clearable
              outlined
              dense
          />
          <v-combobox
              label="Titel Verbund"
              :items="filterValuesVerbund"
              item-text="text"
              item-value="value"
              searchKey="titelVerbund"
              hideDetails="auto"
              clearable
              outlined
              dense
          />
          <v-combobox
              label="Titel Teilvorhaben"
              :items="filterValuesTeilvorhaben"
              item-text="text"
              item-value="value"
              searchKey="titelTeilvorhaben"
              hideDetails="auto"
              clearable
              outlined
              dense
          />
          <v-combobox
              label="Akronym"
              searchKey="akronym"
              :items="filterValuesAkronym"
              item-text="text"
              item-value="value"
              hideDetails="auto"
              clearable
              outlined
              dense
          />
          <v-combobox
              label="Bekanntmachung"
              searchKey="bekanntmachung"
              :items="filterValuesBekanntmachung"
              item-text="text"
              item-value="value"
              hideDetails="auto"
              clearable
              outlined
              dense
          />
          <v-select
              label="Status Verwertung"
              searchKey="abgeschlossen"
              item-text="text"
              item-value="value"
              outlined
              dense
              hide-details="auto"
              :items="statusVerwertungOptionen"
              regular
          />
        </template>
      </BaseLevelTableModule>
    </div>
  </div>
</template>

<script>
import BaseLevelTableModule from '@/components/base_components/BaseLevelTableModule';
import dateFormatService from '@/service/date-format-service';
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: 'ProjektUebersicht',
  components: {
    BaseLevelTableModule,
  },
  data() {
    return {
      filterValuesBearbeiter: [],
      filterValuesVerbund: [],
      filterValuesTeilvorhaben: [],
      filterValuesAkronym: [],
      filterValuesBekanntmachung: [],
      statusVerwertungOptionen: [
        { 'text': 'alle', 'value': null },
        { 'text': 'abgeschlossen', 'value': true},
        { 'text': 'dauert an', 'value': false}
      ],
    };
  },
  computed: {
    ...mapGetters('userData', ['getUserData']),
    pathProjekte() {
      return 'projekt/overview/' + this.getUserData.projekttraegerschaftName;
    },
    headers() {
      return [
        {
          text: 'Titel Verbund',
          value: 'titelVerbund',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Titel Teilvorhaben',
          value: 'titelTeilvorhaben',
          class: "deep-purple lighten-3 white--text"
        },
          {
          text: 'Akronym',
          value: 'acronym',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Förderkennzeichen',
          value: 'foerderkennzeichen',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Zuwendungsempfänger',
          value: 'empfängergruppe',
          class: "deep-purple lighten-3 white--text"
        },
        {
          text: 'Bekanntmachung',
          value: 'titelBK',
          class: "deep-purple lighten-3 white--text"
         
        },
        {
          text: 'Status Verwertung',
          value: 'verwertungAbgeschlossen',
          class: "deep-purple lighten-3 white--text",
          presentWith: this.checkVerwertung
        },
        {
          text: 'Wiedervorlage',
          value: 'wiedervorlage',
          class: "deep-purple lighten-3 white--text",
          presentWith: this.checkWiedervorlage
        },
        {
          text: 'Bearbeiter',
          value: 'bearbeiter',
          class: "deep-purple lighten-3 white--text"
        },
      ]
    }
  },
  mounted() {
    this.getFilterValuesBearbeiter();
    this.getFilterValuesVerbund();
    this.getFilterValuesTeilvorhaben();
    this.getFilterValuesAkronym();
    this.getFilterValuesBekanntmachung();
  },
  methods: {
    checkWiedervorlage(val) {
      if ((val === undefined) || (val === '') || (val === null)) {
        return '-';
      } else {
        return dateFormatService.formatIsoDateString(val);
      }
    },
    checkVerwertung(val){
      if((val=== undefined) || (val === null)){
        return 'Status unbekannt';
      }
      else if((val === false)){
        return 'Verwertung dauert an';
      }
      else{
        return 'Verwertung abgeschlossen';
      }
    },
    getFilterValuesBearbeiter() {
      axios.get(`/v1/projekt/overview/${this.getUserData.projekttraegerschaftName}/bearbeiter`).then((response) => {
        this.filterValuesBearbeiter = response.data;
      });
    },
    getFilterValuesVerbund() {
      axios.get(`/v1/projekt/overview/${this.getUserData.projekttraegerschaftName}/titelVerbund`).then((response) => {
        this.filterValuesVerbund = response.data;
      });
    },
    getFilterValuesTeilvorhaben() {
      axios.get(`/v1/projekt/overview/${this.getUserData.projekttraegerschaftName}/titelTeilvorhaben`).then((response) => {
        this.filterValuesTeilvorhaben = response.data;
      });
    },
    getFilterValuesAkronym() {
      axios.get(`/v1/projekt/overview/${this.getUserData.projekttraegerschaftName}/acronym`).then((response) => {
        this.filterValuesAkronym = response.data;
      });
    },
    getFilterValuesBekanntmachung() {
      axios.get(`/v1/projekt/overview/${this.getUserData.projekttraegerschaftName}/titelBK`).then((response) => {
        this.filterValuesBekanntmachung = response.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>

